import { Member } from '@prisma/client';
import { useMutation, useQuery } from '@tanstack/react-query';
import { AddMemberBodyParams, ListMembersResponse, UpdateMemberParams } from '@zond/api-interfaces';
import { AxiosError } from 'axios';
import { client } from '../../../client';

export const useGetCurrentMember = () => {
  return useQuery<Member>({
    queryKey: ['current-member'],
    queryFn: () => client.get('/members/me').then((res) => res.data),
    retry: 3,
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
  });
};

export const useGetMembers = () => {
  return useQuery<ListMembersResponse>({
    queryKey: ['members'],
    queryFn: () => client.get('/members').then((res) => res.data),
  });
};

export const useAddMember = (
  onSuccess?: (data: Member) => void,
  onError?: (error: AxiosError, variables: AddMemberBodyParams) => void
) => {
  return useMutation<Member, AxiosError, AddMemberBodyParams>({
    mutationFn: (data: AddMemberBodyParams) => client.post('/members', data).then((res) => res.data),
    onSuccess,
    onError,
  });
};

export const useUpdateMember = (onSuccess?: () => void, onError?: () => void) => {
  return useMutation<Member, AxiosError, { memberId: number; data: UpdateMemberParams }>({
    mutationFn: ({ memberId, data }) => client.put(`/members/${memberId}`, data).then((res) => res.data),
    onSuccess,
    onError,
  });
};

export const useDeleteMember = (onSuccess?: () => void, onError?: () => void) => {
  return useMutation<void, AxiosError, number>({
    mutationFn: (memberId: number) => client.delete(`/members/${memberId}`).then((res) => res.data),
    onSuccess,
    onError,
  });
};
